import React from "react";

import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import * as SCConst from "../NonComponents/SCConst";
import { getCatDivStyle } from "../NonComponents/SCUtil";
import SCDrawer from "./SCDrawer";
import TLabel from "../../../Library/Labels/TLabel";
import TCheckBoxLabel from "../../../Library/Labels/TCheckBoxLabel";
import {
    getIndicatorIDs,
    getIndicatorNames,
    getResultIDs,
    getResultNames,
    getDefaultChartType,
    getResultNumInds,
} from "../NonComponents/SCDataUtil";

class SCResultsDrawer extends SCDrawer {
    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    /* Returns the proper height for a div displaying a category based on the number of items in that category. */
    getCatDivHeight = (numItems) => {
        try {
            let height = 40;
            return height + numItems * 20;
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return 0;
        }
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onIndCheckboxChange = (checked, event, name, caption, info) => {
        try {
            let configDrawer = this.state.configDrawer;
            let configExtraDrawer = this.state.configExtraDrawer;
            const indInfo = this.props.indInfo;

            let indsIncluded = configDrawer[SCConst.indsIncluded];
            const numItemsPerInd = indInfo[SCConst.numItemsPerInd];

            const indID = info[SCConst.currID1];

            if (checked) {
                /* Add the indicator to the set of indicators for the custom result if there is currently one or
                   fewer indicators already in the set. The set will be length 1 if there are no indicators,
                   length 2 if there is 1, etc (since we ignore element 0). */
                if (indsIncluded.length < 3) {
                    indsIncluded.push(indID);
                }
            } else {
                let index = indsIncluded.indexOf(indID);
                if (index !== -1) {
                    indsIncluded.splice(index, 1);
                }
            }

            /* Time can only be selected if exactly one indicator is chosen. If two are selected, switch to level.

               Since we switched to level, also default the chart type to bar (line graphs only make sense for graphs
               showing time along the x-axis).

               We also cannot show a trend graph if more than one indicator is shown, so change the graphViewType to
               aggregate instead. */
            if (indsIncluded.length > 2) {
                configDrawer[SCConst.xAxisVar] = SCConst.xAxisLevel;
                configDrawer[SCConst.graphViewType] = SCConst.aggregateView;
                configExtraDrawer.chartTypeClient = SCConst.bar;
            } else if (numItemsPerInd[indID] > 1) {
            /* If there is only one indicator being shown but there is more than one item for
               this indicator, then we can't show it as a trend graph. */
                configDrawer[SCConst.graphViewType] = SCConst.aggregateView;
            }

            //
            // /* Up to two indicators can be checked at a time. Ignore slot 0. If the indicator is already selected, then it will
            //    be in the flexiblePlotIndIDs array. As long as there is another indicator in the array, remove it.  */
            // if ((indIDIdx > -1) && (indsIncluded.length === 3)) {
            //     indsIncluded.splice(indIDIdx, 1);
            // }
            // /* Otherwise, the indicator is not already selected. If two indicators have not already been selected, then add indID
            //    to the array. */
            // else if (indsIncluded.length < 3) {
            //     indsIncluded.push(indID);
            // }
            //
            // /* Time can only be selected if exactly one indicator is chosen. If two are selected, switch to level. Since we
            //    switched to level, also default the chart type to bar. */
            // if (indsIncluded.length > 2) {
            //     configDrawer[SCConst.xAxisVar] = SCConst.xAxisLevel;
            //     configExtraDrawer.chartTypeClient = SCConst.bar;
            // }

            this.setState({
                configDrawer: configDrawer,
                configExtraDrawer: configExtraDrawer,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onResCheckboxChange = (checked, event, name, caption, info) => {
        try {
            let configExtraDrawer = this.state.configExtraDrawer;
            let configDrawer = this.state.configDrawer;
            const displayOL = this.state.displayOL;
            const resID = info[SCConst.currID1];

            /* Exactly one 'Standard' result should be checked off at a time.  */
            if (checked) {
                configExtraDrawer.stdResID = resID;
                configExtraDrawer.resultPlotType = SCConst.standardPlotType;

                /* If the standard result is comprised of multiple indicator, then it cannot be shown
                   as a trend graph, so set the graphViewType to aggregate. */
                if (getResultNumInds(displayOL, resID) > 1) {
                    configDrawer.graphViewType = SCConst.aggregateView;
                }
            } else {
                configExtraDrawer.stdResID = 0;
                configExtraDrawer.resultPlotType = SCConst.flexiblePlotType;
            }

            /* Changing the indicator will affect what kind of chart can be shown, so change the default chart type
               appropriately. */
            configExtraDrawer.chartTypeClient = getDefaultChartType(
                resID,
                this.state.configDrawer,
                configExtraDrawer,
                this.props.displayOL,
                this.props.mstIDsObj
            );

            this.setState({
                configDrawer: configDrawer,
                configExtraDrawer: configExtraDrawer,
            });

            //this.forceUpdate();
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    // onResultPlotTypeRadioChange = (value, info) => {
    //
    //     //const configDrawer = this.state.configDrawer;
    //     let configExtraDrawer = this.state.configExtraDrawer;
    //
    //     configExtraDrawer.resultPlotType = info[SCConst.currID1];
    //
    //     this.setState({configExtraDrawer : configExtraDrawer});
    // };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    createIndCheckBox = (indID, caption, key) => {
        try {
            const configDrawer = this.state.configDrawer;
            const configExtraDrawer = this.state.configExtraDrawer; // mark
            //mark
            // const flexiblePlotIndIDs = configExtraDrawer.flexiblePlotIndIDs;
            // const value = flexiblePlotIndIDs.indexOf(indID) !== -1;
            const indsIncluded = configDrawer[SCConst.indsIncluded];

            const value = indsIncluded.indexOf(indID) !== -1;
            let info = [];
            const enabled = configExtraDrawer.stdResID === 0; // mark

            if (typeof key === "undefined") {
                key = SCConst.indicators + indID;
            }

            info.push(SCConst.indicators);
            info.push(indID);

            return (
                <TCheckBoxLabel
                    caption={caption}
                    enabled={enabled} // mark
                    value={value}
                    info={info}
                    onClick={this.onIndCheckboxChange}
                    key={key}
                    style={{ height: "auto", margin: "margin: 0px 0px 0px 0px" }}
                    labelStyle={{ fontSize: 13 }}
                />
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    createIndCheckboxes = (catID) => {
        try {
            const indInfo = this.props.indInfo;
            const displayOL = JSON.parse(JSON.stringify(this.props.displayOL));
            const mstIDsObj = this.props.mstIDsObj;

            const indIDArray = getIndicatorIDs(mstIDsObj, indInfo, catID);
            const indNamesArray = getIndicatorNames(mstIDsObj, indInfo, catID);
            const resIDArray = getResultIDs(displayOL, mstIDsObj, catID);
            const resNamesArray = getResultNames(displayOL, mstIDsObj, catID);

            let checkBoxArray = [];

            let j = 1;
            if (resNamesArray.length > 0) {
                for (let i = 0; i < resNamesArray.length; i++) {
                    checkBoxArray.push(
                        this.createStdResCheckBox(
                            resIDArray[i],
                            j + ". " + resNamesArray[i] + "*",
                            "Standard result" + i
                        )
                    );
                    j++;
                }
            }

            if (indNamesArray.length > 0) {
                for (let i = 0; i < indNamesArray.length; i++) {
                    checkBoxArray.push(
                        this.createIndCheckBox(indIDArray[i], j + ". " + indNamesArray[i], "Indicator" + i)
                    );
                    j++;
                }
            }

            return checkBoxArray;
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    // original version with only indicators and no results mixed in.
    // createIndCheckboxes = (catID) => {
    //
    //     const indInfo = this.props.indInfo;
    //     const indIDArray = getIndicatorIDs(mstIDsObj, indInfo, catID);
    //     const indNamesArray = getIndicatorNames(mstIDsObj, indInfo, catID);
    //     let checkBoxArray = [];
    //
    //     for (let i = 0; i < indNamesArray.length; i++) {
    //         checkBoxArray.push(this.createIndCheckBox(indIDArray[i], (i + 1) + '. ' + indNamesArray[i], i));
    //     }
    //
    //     return checkBoxArray;
    // };

    createIndCatDivs = () => {
        try {
            const styles = SCConst.styles;

            const mstIDsObj = this.props.mstIDsObj;
            const catInfo = this.props.catInfo;

            const catNames = catInfo[SCConst.catNames];

            let indCatDivs = [];
            let catDivStyles = getCatDivStyle();

            for (let i = 0; i < catNames.length - 1; i++) {
                const catCurrID = i + 1;
                const catMstID = mstIDsObj[SCConst.catMstIDs][catCurrID];

                if (catMstID !== SCConst.cat_SetupMstID && catMstID !== SCConst.cat_CharMstID) {
                    let indIDArray = getIndicatorIDs(mstIDsObj, this.props.indInfo, catCurrID);
                    let resIDArray = getResultIDs(this.props.displayOL, mstIDsObj, catCurrID);

                    if (indIDArray.length + resIDArray.length > 0) {
                        //catDivStyles.height = this.getCatDivHeight(indIDArray.length);

                        indCatDivs.push(
                            <div
                                key={"indCatDivs" + i}
                                style={catDivStyles}
                            >
                                <TLabel
                                    caption={catNames[catCurrID]}
                                    key={"indCatNameLab" + i}
                                    style={styles.label}
                                />

                                <div
                                    key={"indCatCheckboxesDiv" + i}
                                    style={styles.checkboxes}
                                >
                                    {this.createIndCheckboxes(catCurrID)}
                                </div>
                            </div>
                        );
                    }
                }
            }

            return indCatDivs;
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    // original version with only indicators and no results mixed in.
    // createIndCatDivs = () => {
    //     const styles = SCConst.styles;
    //
    //     let indCatDivs = [];
    //     let catDivStyles = getCatDivStyle();
    //
    //     const catInfo = this.props.catNames;
    //     const catNames = catInfo[SCConst.catNames];
    //
    //     for (let i = 0; i < (catNames.length - 1); i++) {
    //         const catID = i + 1;
    //         const catMstID = mstIDsObj[SCConst.catMstIDs][catCurrID];
    //
    //         if ((catMstID !== SCConst.cat_SetupMstID) && (catMstID !== SCConst.cat_CharMstID)) {
    //             let indIDArray = getIndicatorIDs(mstIDsObj, this.props.indInfo, catID);
    //
    //             if (indIDArray.length > 0) {
    //                 //catDivStyles.height = this.getCatDivHeight(indIDArray.length);
    //
    //                 indCatDivs.push(
    //                     <div style={catDivStyles}>
    //                         <TLabel caption={catNames[catCurrID]} style={styles.label}/>
    //                         <div style={styles.checkboxes}>
    //                             {this.createIndCheckboxes(catNames[catCurrID])}
    //                         </div>
    //                     </div>
    //                 );
    //             }
    //         }
    //     }
    //
    //     return indCatDivs;
    // };

    createStdResCheckBox = (resID, caption, key) => {
        try {
            const configExtraDrawer = this.state.configExtraDrawer;

            if (typeof key === "undefined") {
                key = SCConst.displays + resID;
            }

            let info = [];
            const value = configExtraDrawer.stdResID === resID ? true : false;

            info.push(SCConst.displays);
            info.push(resID);

            return (
                <TCheckBoxLabel
                    caption={caption}
                    value={value}
                    info={info}
                    onClick={this.onResCheckboxChange}
                    key={key}
                    style={{ height: "auto", margin: "margin: 0px 0px 0px 0px" }}
                    labelStyle={{ fontSize: 13 }}
                />
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* Generic function for creating checkboxes. If your checkboxes need new parameters, make a different function
       to avoid giving this a massive parameter list, since most checkboxes won't need all those parameters. */
    // createStdResCheckboxes = (catID) => {
    //     let checkBoxArray = [];
    //     const displayOL = JSON.parse(JSON.stringify(this.props.displayOL));
    //     const mstIDsObj = this.props.mstIDsObj;
    //     const resIDArray = getResultIDs(displayOL, mstIDsObj, catID);
    //     const resNamesArray = getResultNames(displayOL, mstIDsObj, catID);
    //
    //     for (let i = 0; i < resNamesArray.length; i++) {
    //         checkBoxArray.push(this.createStdResCheckBox(resIDArray[i], resNamesArray[i], i));
    //     }
    //
    //     return checkBoxArray;
    // };

    // createStdResCatDivs = () => {
    //     const styles = SCConst.styles;
    //
    //     const mstIDsObj = this.props.mstIDsObj;
    //     const catInfo = this.props.catInfo;
    //     const catNames = catInfo[SCConst.catNames];
    //
    //     let stdResCatDivs = [];
    //     let catDivStyles = getCatDivStyle();
    //
    //     for (let i = 0; i < (catNames.length - 1); i++) {
    //         const catID = i + 1;
    //         const catMstID = mstIDsObj[SCConst.catMstIDs][catCurrID];
    //
    //         if ((catMstID !== SCConst.cat_SetupMstID) && (catMstID !== SCConst.cat_CharMstID)) {
    //             let resIDArray = getResultIDs(this.props.displayOL, mstIDsObj, catID);
    //
    //             if (resIDArray.length > 0) {
    //                 //catDivStyles.height = this.getCatDivHeight(resIDArray.length);
    //
    //                 stdResCatDivs.push(
    //                     <div style={catDivStyles}>
    //                         <TLabel caption={catNames[catCurrID]} style={styles.label}/>
    //                         <div style={styles.checkboxes}>
    //                             {this.createStdResCheckboxes(catID)}
    //                         </div>
    //                     </div>
    //                 );
    //             }
    //         }
    //     }
    //
    //     return stdResCatDivs;
    // };

    renderResults = () => {
        try {
            //const configDrawer = this.state.configDrawer;
            //const configExtraDrawer = this.state.configExtraDrawer;
            //const indInfo = this.props.indInfo;
            // const resultPlotType = configExtraDrawer.resultPlotType;
            //const styles = SCConst.styles;

            // const resultPlotTypeRadioGroup =
            //     <TRadioGroup
            //         itemIndex={resultPlotType - 1}
            //         items={[
            //             "Standard",
            //             "Flexible plotting"
            //         ]}
            //         handleChange={this.onResultPlotTypeRadioChange}
            //         info={[
            //             [SCConst.resultPlotType, 1],
            //             [SCConst.resultPlotType, 2],
            //         ]}
            //         row={true}
            //     />;

            return (
                <section style={{ margin: "10px 10px 10px 20px" }}>
                    {/*{resultPlotTypeRadioGroup}*/}
                    {
                        // (resultPlotType === SCConst.standardPlotType) ?
                        //     <section>
                        //         <h5>Select one</h5>
                        //         {this.createStdResCatDivs()}
                        //         <div style={{clear: 'both'}}/>
                        //     </section>
                        //     :
                        <section>
                            <h5>
                                Select up to two (results marked with * cannot be displayed together with other results)
                            </h5>
                            {this.createIndCatDivs()}
                            <div style={{ clear: "both" }} />
                        </section>
                    }
                </section>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
            return null;
        }
    };

    render() {
        try {
            const configDrawer = this.state.configDrawer;

            if (configDrawer === null) {
                return null;
            }

            return this.renderResults();
        } catch (exception) {
            return (
                <div
                    className={"SCResultsDrawerDiv"}
                    key={"SCResultsDrawerDiv"}
                >
                    <h3 key={"SCResultsDrawerDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCResultsDrawer;
